module.exports = __webpack_public_path__ + "assets/img/18.f45ac1f5.png";